export default {
  appName: "Sep Dashboard",

  // Navigation
  navigation: {
    dashboard: "Dashboard",
    leads: "Leads",
    opportunities: "Sales",
    customers: "Customers",
    organizations: "Organizations",
    inbasket: "Task List",
    manuals: "User Manuals",
    profile: "Profile",

    // Sidebar menu labels (different from breadcrumb)
    sidebar: {
      Opportunity: "Sales",
    },

    // Dynamic item types - exact Aras ItemType names
    // Core ItemTypes
    Lead: "Lead",
    Lead_plural: "Leads",
    Leads: "Leads",
    Opportunity: "Opportunity",
    Opportunity_plural: "Sales Opportunities",
    Customer: "Customer",
    Customer_plural: "Customers",
    Organization: "Organization",
    Organization_plural: "Organizations",
    Address: "Address",
    Address_plural: "Addresses",
    Person: "Person",
    Person_plural: "Persons",
    Contact: "Contact",
    Contact_plural: "Contacts",

    // Internal/Support ItemTypes
    Department: "Department",
    Department_plural: "Departments",
    Position: "Position",
    Position_plural: "Positions",
    Task: "Task",
    Task_plural: "Tasks",
    Product: "Product",
    Product_plural: "Products",
    Employee: "Employee",
    Employee_plural: "Employees",
    Referrer: "Referrer",
    Referrer_plural: "Referrers",
    Document: "Document",
    Document_plural: "Documents",
    Campaign: "Campaign",
    Campaign_plural: "Campaigns",

    // Education & Facility ItemTypes
    EducationFacility: "Education Facility",
    EducationFacility_plural: "Education Facilities",
    Facility: "Facility",
    Facility_plural: "Facilities",

    // Lead ItemTypes
    ServiceNeed: "Service Need",
    ServiceNeed_plural: "Service Needs",

    // Customer ItemTypes
    CustomerTier: "Customer Tier",
    CustomerTier_plural: "Customer Tiers",
    PricingPolicy: "Pricing Policy",
    PricingPolicy_plural: "Pricing Policies",

    // Sales ItemTypes
    Proposal: "Proposal",
    Proposal_plural: "Proposals",
    Contract: "Contract",
    Contract_plural: "Contracts",

    // Operations ItemTypes
    Class: "Class",
    Class_plural: "Classes",
    Student: "Student",
    Student_plural: "Students",
    Attendance: "Attendance",
    Attendance_plural: "Attendances",
    Revenue: "Revenue",
    Revenue_plural: "Revenues",

    // Care ItemTypes
    CarePlan: "Care Plan",
    CarePlan_plural: "Care Plans",
    CareActivity: "Care Activity",
    CareActivity_plural: "Care Activities",

    // Geographic (List ItemTypes displayed as items)
    Province: "Province/City",
    Province_plural: "Provinces/Cities",
    District: "District",
    District_plural: "Districts",
    Ward: "Ward",
    Ward_plural: "Wards",

    // Legacy lowercase keys (keep for backward compatibility)
    addresses: "Addresses",
    persons: "Persons",
    workflows: "Workflows",
    "workflow-maps": "Workflow Maps",
    contacts: "Contacts",
    products: "Products",
    campaigns: "Campaigns",
    contracts: "Contracts",
    proposals: "Proposals",
    invoices: "Invoices",
    projects: "Projects",
    tasks: "Tasks",
    activities: "Activities",
    departments: "Departments",
    positions: "Positions",
    employees: "Employees",
    referrers: "Referrers",
    documents: "Documents",
    educationFacilities: "Education Facilities",
    facilities: "Facilities",
    serviceNeeds: "Service Needs",
    customerTiers: "Customer Tiers",
    pricingPolicies: "Pricing Policies",
    classes: "Classes",
    students: "Students",
    attendances: "Attendances",
    revenues: "Revenues",
    carePlans: "Care Plans",
    careActivities: "Care Activities",
    provinces: "Provinces/Cities",
    districts: "Districts",
    wards: "Wards",
  },

  // Auth
  auth: {
    signIn: "Sign in",
    signInToAccount: "Sign in to your account",
    username: "Username",
    userPass: "Password",
    enterUsername: "Enter your username",
    enterPass: "Enter your password",
    loginFailed: "Login failed",
    usernameRequired: "Please enter your username",
    passRequired: "Please enter your password",
    logout: "Logout",
    // Error messages
    invalidCredentials: "Invalid username or password",
    accountDisabled: "Your account has been disabled",
    tooManyAttempts: "Too many failed attempts. Please try again later",
    serverError: "Server error. Please try again later",
    networkError:
      "Cannot connect to server. Please check your network connection",
    mfa: {
      verifyTitle: "Two-Factor Authentication",
      enterCode: "Enter the 6-digit code from your authenticator app",
      enterBackupCode: "Enter one of your backup codes",
      backupCodePlaceholder: "ABCD1234",
      verify: "Verify",
      trustDevice: "Trust this device for 30 days",
      useBackupCode: "Use a backup code",
      useAuthenticator: "Use authenticator app",
      backToLogin: "Back to login",
      invalidCode: "Invalid verification code",
      codeExpired: "Verification session expired. Please login again",
      tooManyAttempts: "Too many attempts. Please login again",
      setupTitle: "Set Up Two-Factor Authentication",
      scanQrCode: "Scan this QR code with your authenticator app",
      manualEntry: "Or enter this key manually",
      confirmSetup: "Enter the code shown in your app to confirm",
      setupSuccess: "Two-factor authentication enabled successfully",
      backupCodesTitle: "Backup Codes",
      backupCodesInfo:
        "Save these codes in a safe place. Each code can only be used once.",
      backupCodesRemaining: "{{count}} backup codes remaining",
      regenerateBackupCodes: "Regenerate Backup Codes",
      copyAll: "Copy All",
      download: "Download",
      enabled: "Two-factor authentication is enabled",
      disabled: "Two-factor authentication is not enabled",
      enable: "Enable 2FA",
      disable: "Disable 2FA",
      securityTitle: "Account Security",
      disableConfirm: "Enter your current code to disable 2FA",
      regenerateConfirm: "Enter your current code to regenerate backup codes",
      enrollmentRequired:
        "Your organization requires two-factor authentication. Please set up 2FA to continue.",
    },
  },

  // Dashboard
  dashboard: {
    welcomeBack: "Welcome back, {{name}}!",
    placeholder: {
      title: "Dashboard Coming Soon",
      description:
        "This is a placeholder dashboard. Configure VITE_DASHBOARD_TYPE environment variable to enable specific dashboard modules.",
      configure: "Configure",
      getStarted: "Get Started",
      feature1: "Feature 1",
      feature1Desc: "Description for feature 1",
      feature2: "Feature 2",
      feature2Desc: "Description for feature 2",
      feature3: "Feature 3",
      feature3Desc: "Description for feature 3",
    },
    overview: "Overview of your business activities",
    totalLeads: "Leads",
    leads: "Leads",
    opps: "Opps",
    customers: "Customers",
    tasks: "Tasks",
    pendingTasks: "Pending Tasks",
    pipelineValue: "Pipeline Value",
    conversionRate: "Conversion Rate",
    opportunities: "Opportunities",
    totalCustomers: "Customers",
    recentLeads: "Recent Leads",
    recentOpportunities: "Recent Opportunities",
    viewAll: "View all",
    noLeadsYet: "No leads yet",
    noPendingTasks: "No pending tasks",
    noOpportunities: "No opportunities yet",
    noEmail: "No email",
    noDueDate: "No due date",
    due: "Due: {{date}}",
    newLead: "New Lead",
    leadsThisMonth: "{{count}} recent leads",
    tasksToday: "Requires attention",
    activity: "Activity",
    itemType: "Type",
    salesPipeline: "Sales Pipeline",
    topOpportunities: "Top Opportunities",
    overdue: "Overdue",
    inPeriod: "in period",
  },

  // Table columns
  table: {
    id: "ID",
    name: "Name",
    company: "Company",
    email: "Email",
    phone: "Phone",
    priority: "Priority",
    status: "Status",
    value: "Value",
    state: "State",
    actions: "Actions",
    siteId: "Branch",
    customer: "Customer",
    stage: "Stage",
    amount: "Amount",
    probability: "Probability",
    segment: "Segment",
    city: "City",
    type: "Type",
    source: "Source",
    dueDate: "Due Date",
    searchPlaceholder: "Enter information to search...",
    allFields: "All fields",
    selectFilter: "Select...",
    searchName: "Search name",
    industry: "Industry",
    size: "Size",
    employees: "Employees",
    country: "Country",
    // InBasket columns
    sourceItem: "Source Item",
    activity: "Activity",
    startDate: "Start Date",
    assignedTo: "Assigned To",
    instructions: "Instructions",
    assigned_sales_id: "Assigned Sales ID",
    education_facility: "Education Facility",
    item_number: "Item Number",
    itemNumber: "Item Number",
    // Column settings
    columns: "Columns",
    columnSettings: "Column Settings",
    noData: "No data",
    resetColumns: "Reset to default",
    // Boolean checkbox
    checkAll: "Check all",
    uncheckAll: "Uncheck all",
    selectAll: "All",
  },

  // Priority
  priority: {
    high: "High",
    medium: "Medium",
    low: "Low",
  },

  // Status
  status: {
    new: "New",
    contacted: "Contacted",
    qualified: "Qualified",
    negotiation: "Negotiation",
    won: "Won",
    lost: "Lost",
    active: "Active",
    inactive: "Inactive",
    prospect: "Prospect",
    churned: "Churned",
    draft: "Draft",
    pending: "Pending",
  },

  // Stage
  stage: {
    qualification: "Qualification",
    needsAnalysis: "Needs Analysis",
    proposal: "Proposal",
    negotiation: "Negotiation",
    closedWon: "Closed Won",
    closedLost: "Closed Lost",
  },

  // Segment
  segment: {
    enterprise: "Enterprise",
    smb: "SMB",
    startup: "Startup",
    individual: "Individual",
  },

  // Buttons for Refine
  buttons: {
    create: "Create",
    save: "Save",
    edit: "Edit",
    delete: "Delete",
    cancel: "Cancel",
    confirm: "Confirm",
    list: "List",
    show: "Show",
    refresh: "Refresh",
    add: "Add",
    addExisting: "Add Existing",
    createNew: "Create New",
    populateFrom: "Populate from {{source}}",
    populating: "Populating...",
    view: "View",
    download: "Download",
    change: "Change",
    close: "Close",
    select: "Select",
    yes: "Yes",
    no: "No",
    clear: "Clear",
    filter: "Filter",
    confirmDelete: "This action cannot be undone.",
    preview: "Preview",
    selectFile: "Select File",
    duplicate: "Duplicate",
  },

  // Actions
  actions: {
    show: "Show",
    edit: "Edit",
    delete: "Delete",
    create: "Create",
    save: "Save",
    cancel: "Cancel",
    complete: "Complete",
    ok: "OK",
    confirm: "Confirm",
    duplicate: "Duplicate",
  },

  // Page titles
  titles: {
    editLead: "Edit Lead",
    showLead: "Lead Details",
    editOpportunity: "Edit Opportunity",
    showOpportunity: "Opportunity Details",
    editCustomer: "Edit Customer",
    showCustomer: "Customer Details",
    editOrganization: "Edit Organization",
    showOrganization: "Organization Details",
  },

  // Workflow / InBasket
  workflow: {
    // InBasket item types
    workflowTask: "Workflow Task",

    // InBasket
    inbasket: "In-Basket",
    completeTask: "Complete Task",
    activityCompletion: "Workflow Activity Completion",
    workflowName: "Workflow",
    activity: "Activity",
    task: "Task",
    item: "Item",
    vote: "Vote",
    selectPath: "Select a path to complete this task:",
    selectPathPlaceholder: "Select path",
    comments: "Comments",
    commentsPlaceholder: "Enter comments (optional)...",
    taskCompleted: "Task completed successfully",
    taskCompletedDescription:
      "The task has been approved and moved to the next step.",
    taskFailed: "Failed to complete task",
    taskFailedDescription:
      "An error occurred while approving the task. Please try again.",
    pathNotFound: "Path not found",
    pathNotFoundDescription: "Workflow path not found. Please try again.",
    totalItems: "Total {{total}} items",
    // Workflow Visualization
    button: "Workflow",
    title: "Workflow Process",
    noWorkflow: "No workflow assigned",
    startedBy: "Started By",
    activeDate: "Active Date",
    closedDate: "Closed Date",
    processOwner: "Process Owner",
    legend: {
      start: "Start",
      completed: "Completed",
      active: "Active",
      pending: "Pending",
      end: "End",
      auto: "Auto",
    },
    backToList: "Back to list",
    voteCompletedTitle: "Vote completed successfully",
    // Workflow History Report
    history: {
      title: "Workflow",
      reportTitle: "Workflow History Report",
      item: "Item",
      currentStatus: "Current Status is",
      startedBy: "Started By",
      startedOn: "Started On",
      completedOn: "Completed On",
      activity: "Activity",
      state: "State",
      assignedTo: "Assigned To",
      completedBy: "Completed By",
      howVoted: "How Voted",
      when: "When",
      comments: "Comments",
      voteNow: "VOTE NOW",
      noWorkflow: "No workflow assigned to this item",
      exportExcel: "Export to Excel",
      exportWord: "Export to Word",
    },
  },

  // Lifecycle
  lifecycle: {
    title: "Lifecycle Status",
    status: "Lifecycle Status",
    completed: "completed",
    current: "Current",
    pending: "Pending",
    noLifecycle: "No lifecycle information",
    statesCompleted: "{{completed}} / {{total}} completed",
    availableActions: "Available Actions",
    promoteTo: "Promote to {{state}}",
    confirmPromotion: "Confirm Promotion",
    confirmPromoteMessage:
      "Are you sure you want to promote this item to <strong>{{state}}</strong>?",
    promotedSuccess: "Item promoted to {{state}}",
    promoteFailed: "Failed to promote item",
    promoting: "Promoting...",
  },

  // Kanban board
  kanban: {
    viewMode: "Kanban",
    uncategorized: "Uncategorized",
    items: "{{count}} items",
    items_one: "1 item",
    noItems: "No items",
    notAvailable: "Kanban view is not available",
    promoteSuccess: "Promoted to {{state}}",
    promoteError: "Failed to promote item",
    voteTitle: "Workflow Vote Required",
    voteSuccess: "Vote submitted: {{path}}",
    voteError: "Failed to submit vote",
    transitionNotAllowed: "Cannot move directly from {{from}} to {{to}}",
    showingLimit: "Showing first {{count}} items. Use filters to narrow down.",
  },

  // Assignment
  assignment: {
    title: "Assignment",
    owner: "Owner",
    assignedTo: "Assigned To",
  },

  // Language
  language: {
    switch: "Switch Language",
    vi: "Tiếng Việt",
    en: "English",
  },

  // Pagination
  pagination: {
    total: "Total {{total}} items",
  },

  // Forms
  forms: {
    leadInformation: "Lead Information",
    customerInformation: "Customer Information",
    opportunityInformation: "Opportunity Information",
    organizationInformation: "Organization Information",
    parentOrganization: "Parent Organization",
    contactInformation: "Contact Information",
    companyInformation: "Company Information",
    notes: "Notes",
    dates: "Dates",
    relatedEntities: "Related Entities",

    // Labels
    id: "ID",
    name: "Name",
    priority: "Priority",
    source: "Source",
    expectedCloseDate: "Expected Close Date",
    estimatedValue: "Estimated Value",
    currency: "Currency",
    description: "Description",
    contactName: "Contact Name",
    position: "Position",
    email: "Email",
    phone: "Phone",
    companyName: "Company Name",
    industry: "Industry",
    website: "Website",
    created: "Created",
    lastModified: "Last Modified",
    expectedClose: "Expected Close",
    lastContact: "Last Contact",
    actualClose: "Actual Close",
    stage: "Stage",
    type: "Type",
    amount: "Amount",
    probability: "Probability",
    status: "Status",
    segment: "Segment",
    rating: "Rating",
    lead: "Lead",
    customer: "Customer",
    organization: "Organization",
    totalRevenue: "Total Revenue",
    firstPurchase: "First Purchase",
    lastPurchase: "Last Purchase",
    address: "Address",
    city: "City",
    country: "Country",
    postalCode: "Postal Code",

    // Placeholders
    selectPriority: "Select priority",
    selectSource: "Select source",
    selectIndustry: "Select industry",
    selectStage: "Select stage",
    selectType: "Select type",
    selectSegment: "Select segment",
    selectSize: "Select size",
    selectRating: "Select rating",
    selectStatus: "Select status",
    addNotes: "Add notes about this lead...",
    addNotesCustomer: "Add notes about this customer...",
    addNotesOpportunity: "Add notes about this opportunity...",
    addNotesOrganization: "Add notes about this organization...",

    // Validation
    nameRequired: "Name is required",
    invalidEmail: "Invalid email",
    invalidUrl: "Invalid URL",

    assigned_sales_id: "Assigned Sales ID",
    item_number: "Item Number",
    itemNumber: "Item Number",

    // Additional sections for Dynamic Form
    addressInformation: "Address Information",
    basicInformation: "Basic Information",
  },

  // Sources
  sources: {
    website: "Website",
    referral: "Referral",
    socialMedia: "Social Media",
    tradeShow: "Trade Show",
    coldCall: "Cold Call",
    other: "Other",
  },

  // Industries
  industries: {
    technology: "Technology",
    education: "Education",
    healthcare: "Healthcare",
    finance: "Finance",
    retail: "Retail",
    manufacturing: "Manufacturing",
    other: "Other",
  },

  // Aras Value Lists (List_* translations)
  lists: {
    // Marketing Lists
    marketingChannel: {
      _label: "Marketing Channel",
      online: "Online",
      offline: "Offline",
      social_media: "Social Media",
      email: "Email",
      event: "Event",
      referral: "Referral",
      direct: "Direct",
      partner: "Partner",
      advertising: "Advertising",
      other: "Other",
    },
    leadSource: {
      _label: "Lead Source",
      website: "Website",
      facebook: "Facebook",
      zalo: "Zalo",
      google: "Google",
      referral: "Referral",
      event: "Event",
      cold_call: "Cold Call",
      partner: "Partner",
      advertising: "Advertising",
      email_campaign: "Email Campaign",
      trade_show: "Trade Show",
      word_of_mouth: "Word of Mouth",
      other: "Other",
    },
    productAwareness: {
      _label: "Product Awareness",
      yes: "Yes",
      no: "No",
    },
    leadClassification: {
      _label: "Lead Classification",
      hot: "Hot",
      warm: "Warm",
      cold: "Cold",
    },
    leadEligibility: {
      _label: "Lead Eligibility",
      eligible: "Eligible",
      not_eligible: "Not Eligible",
    },
    interactionStatus: {
      _label: "Interaction Status",
      new: "New",
      contacted: "Contacted",
      interested: "Interested",
      not_interested: "Not Interested",
      follow_up: "Follow Up",
      qualified: "Qualified",
      unqualified: "Unqualified",
      converted: "Converted",
      lost: "Lost",
    },

    // Status Lists
    workStatus: {
      _label: "Work Status",
      not_started: "Not Started",
      in_progress: "In Progress",
      completed: "Completed",
      on_hold: "On Hold",
      cancelled: "Cancelled",
      pending: "Pending",
    },
    salesStatus: {
      _label: "Sales Status",
      active: "Active",
      inactive: "Inactive",
    },
    salesMethod: {
      _label: "Sales Method",
      direct: "Direct",
      online: "Online",
      phone: "Phone",
      email: "Email",
      partner: "Partner",
      event: "Event",
    },
    approvalStatus: {
      _label: "Approval Status",
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
      revision: "Needs Revision",
      cancelled: "Cancelled",
    },
    infoStatus: {
      _label: "Info Status",
      draft: "Draft",
      active: "Active",
      inactive: "Inactive",
    },
    paymentStatus: {
      _label: "Payment Status",
      pending: "Pending",
      paid: "Paid",
      overdue: "Overdue",
    },
    documentStatus: {
      _label: "Document Status",
      draft: "Draft",
      submitted: "Submitted",
      approved: "Approved",
      rejected: "Rejected",
      archived: "Archived",
    },
    classStatus: {
      _label: "Class Status",
      planning: "Planning",
      active: "Active",
      completed: "Completed",
      cancelled: "Cancelled",
      suspended: "Suspended",
    },
    customerStatus: {
      _label: "Customer Status",
      prospect: "Prospect",
      active: "Active",
      inactive: "Inactive",
      churned: "Churned",
      suspended: "Suspended",
    },

    // Sales Lists
    opportunitySalesStage: {
      _label: "Sales Stage",
      prospecting: "Prospecting",
      discovery: "Discovery",
      demo: "Demo",
      proposal: "Proposal",
      negotiation: "Negotiation",
      closed_won: "Closed Won",
      closed_lost: "Closed Lost",
      on_hold: "On Hold",
    },
    proposalStatus: {
      _label: "Proposal Status",
      draft: "Draft",
      sent: "Sent",
      viewed: "Viewed",
      accepted: "Accepted",
      rejected: "Rejected",
      expired: "Expired",
      revised: "Revised",
      cancelled: "Cancelled",
    },
    contractStatus: {
      _label: "Contract Status",
      draft: "Draft",
      reviewing: "Reviewing",
      pending: "Pending Signature",
      active: "Active",
      suspended: "Suspended",
      expired: "Expired",
      terminated: "Terminated",
      renewed: "Renewed",
    },
    contractType: {
      _label: "Contract Type",
      new: "New",
      renewal: "Renewal",
      amendment: "Amendment",
      termination: "Termination",
      other: "Other",
    },

    // Product & Service Lists
    product: {
      _label: "Product/Service",
      teaching: "Teaching",
      event: "Event",
      gotrip: "GoTrip",
      sportweek: "Sport Week",
      teacher_training: "Teacher Training",
      franchise: "Franchise",
      demo_class: "Demo Class",
      demo_school: "Demo School",
      coaching: "Coaching",
      observation: "Observation",
      enrollment: "Enrollment",
      playground: "Playground",
    },
    documentType: {
      _label: "Document Type",
      contract: "Contract",
      proposal: "Proposal",
      invoice: "Invoice",
      report: "Report",
      certificate: "Certificate",
      license: "License",
      agreement: "Agreement",
      letter: "Letter",
      form: "Form",
      manual: "Manual",
      policy: "Policy",
      procedure: "Procedure",
      presentation: "Presentation",
      image: "Image",
      video: "Video",
      audio: "Audio",
      spreadsheet: "Spreadsheet",
      database: "Database",
      archive: "Archive",
      other: "Other",
    },

    // Operation Lists
    studentStatus: {
      _label: "Student Status",
      active: "Active",
      inactive: "Inactive",
    },
    studentType: {
      _label: "Student Type",
      regular: "Regular",
      scholarship: "Scholarship",
      special: "Special",
    },
    facilityCondition: {
      _label: "Facility Condition",
      good: "Good",
      needs_repair: "Needs Repair",
    },
    location: {
      _label: "Location",
      school: "At School",
      center: "At Center",
      outdoor: "Outdoor",
    },
    coachType: {
      _label: "Coach Type",
      lead: "Lead Coach",
      support: "Support Coach",
      intern: "Intern",
      guest: "Guest",
    },

    // Care Lists
    careAction: {
      _label: "Care Action",
      call: "Phone Call",
      visit: "Visit",
      email: "Send Email",
      gift: "Gift",
      event: "Invite to Event",
    },
    careItem: {
      _label: "Care Item",
      birthday: "Birthday",
      holiday: "Holiday",
      regular: "Regular",
    },
    careResult: {
      _label: "Care Result",
      successful: "Successful",
      partial: "Partial",
      unsuccessful: "Unsuccessful",
    },

    // Industry Lists
    industry: {
      _label: "Industry",
      education: "Education",
      healthcare: "Healthcare",
      technology: "Technology",
      finance: "Finance",
      retail: "Retail",
      manufacturing: "Manufacturing",
      construction: "Construction",
      real_estate: "Real Estate",
      hospitality: "Hospitality/Tourism",
      transportation: "Transportation",
      agriculture: "Agriculture",
      energy: "Energy",
      media: "Media",
      consulting: "Consulting",
      legal: "Legal",
      government: "Government",
      nonprofit: "Non-profit",
      sports: "Sports",
      entertainment: "Entertainment",
      food_beverage: "Food & Beverage",
      fashion: "Fashion",
      other: "Other",
    },
    businessType: {
      _label: "Business Type",
      private: "Private",
      public: "Public",
      state_owned: "State-owned",
      joint_venture: "Joint Venture",
      foreign: "Foreign",
      cooperative: "Cooperative",
      household: "Household Business",
      individual: "Individual",
      ngo: "NGO",
      association: "Association",
      other: "Other",
    },

    // Education Lists
    educationLevel: {
      _label: "Education Level",
      preschool: "Preschool",
      primary: "Primary",
      secondary: "Secondary",
      high_school: "High School",
      vocational: "Vocational",
      college: "College",
      university: "University",
    },

    // Other Lists
    yesNoUnknown: {
      _label: "Yes/No/Unknown",
      yes: "Yes",
      no: "No",
      unknown: "Unknown",
    },
    personType: {
      _label: "Person Type",
      owner: "Owner",
      manager: "Manager",
      principal: "Principal",
      teacher: "Teacher",
      parent: "Parent",
      other: "Other",
    },
  },

  // Site scoping
  site: {
    title: "Site",
    allSites: "All Sites",
    selectSite: "Select site",
    currentSite: "Current Site",
    noSite: "No site assigned",
    headquarters: "Headquarters",
    yourSite: "Your site: {{site}}",
  },

  // Tabs
  tabs: {
    details: "Details",
  },

  // Common
  common: {
    loading: "Loading...",
    noData: "-",
    normal: "Normal",
    yes: "Yes",
    no: "No",
    on: "On",
    off: "Off",
    totalItems: "Total {{total}} items",
    noItems: "No items found",
    version: "Version",
  },

  // Fields (for dynamic table columns)
  fields: {
    name: "Name",
    itemNumber: "Item Number",
    state: "State",
    filename: "Filename",
    fileSize: "Size",
    comments: "Comments",
    createdOn: "Created",
    relatedItem: "Related Item",
    sortOrder: "Sort Order",
    file: "File",
  },

  // Placeholders
  placeholders: {
    comments: "Enter comments (optional)",
    sortOrder: "Enter sort order",
  },

  // Messages
  messages: {
    loading: "Loading...",
    previewNotSupported: "Preview not available for this file type",
    success: "Success",
  },

  // Errors
  errors: {
    fetchFailed: "Failed to load data",
    resourceNotFound: "Resource not found: {{resource}}",
    metadataFailed: "Failed to load table configuration",
    metadataFailedDesc: "Please try again or contact support.",
    validationError: "Validation Error",
    selectFile: "Please select a file",
    uploadFailed: "Upload Failed",
    unknownError: "Unknown error occurred",
  },

  // Dynamic Form
  dynamicForm: {
    fieldRequired: "{{field}} is required",
    maxLength: "Maximum {{max}} characters",
    invalidFormat: "Invalid format",
    invalidEmail: "Invalid email address",
    invalidUrl: "Invalid URL",
    enter: "Enter {{field}}",
    select: "Select {{field}}",
    selectDate: "Select date",
    selectDateTime: "Select date and time",
    selectTime: "Select time",
    selectItem: "Select {{itemType}}",
    selectMultiple: "Select one or more {{field}}",
    noItemsFound: "No items found",
    enterImageUrl: "Enter image URL",
    autoGenerated: "Auto-generated",
    metadataError: "Failed to load form configuration",
    usingFallback: "Using default form configuration",
    additionalFields: "Additional Information",
    // Add new related item
    addNew: "Add new {{itemType}}",
    createNew: "Create new {{itemType}}",
    loadingMetadata: "Loading form...",
    createError: "Failed to create item",
    createSuccess: "{{itemType}} created successfully",
    // File upload
    existingFile: "Existing file",
    fileTooLarge: "File size exceeds {{maxSize}} limit",
    fileUploaded: "{{fileName}} uploaded successfully",
    uploadFailed: "Upload failed",
    downloadFailed: "Download failed",
    previewFailed: "Preview failed",
    loadingFile: "Loading file information...",
    uploading: "Uploading...",
    uploadHint: "Click or drag file to this area to upload",
    uploadMaxSize: "Maximum file size: {{maxSize}}",
    replaceFile: "Replace file",
    noFormConfigured: "Form not configured",
    noFormConfiguredDesc:
      "Please contact the administrator to set up the form.",
  },

  // Notifications (Refine default keys)
  notifications: {
    // Create
    createSuccess: "Successfully created",
    createError: "Error when creating",
    // Edit/Update
    editSuccess: "Successfully updated",
    editError: "Error when updating",
    // Delete
    deleteSuccess: "Successfully deleted",
    deleteError: "Error when deleting",
    // Populate
    populateSuccess: "Successfully added {{count}} items",
    populatePartialSuccess:
      "Added {{count}} items (some sources failed to load)",
    populateError: "Failed to populate items",
    populateNoSource: "No linked {{source}} found",
    populateNoItems: "No items found in {{source}}",
    populateAllExist: "All items already exist in the list",
    // Bulk add
    bulkAddSuccess: "Successfully added {{count}} items",
    // Errors
    error: "An error occurred",
    undoable: "You have {{seconds}} seconds to undo",
    success: "Success",
    // HTTP Error messages
    httpError: {
      400: "Bad request",
      401: "Session expired",
      403: "You don't have permission to perform this action",
      404: "Data not found",
      408: "Request timeout",
      409: "Data conflict. Please refresh and try again",
      422: "Invalid data",
      429: "Too many requests. Please try again later",
      500: "Server error. Please try again later",
      502: "Cannot connect to server",
      503: "Service temporarily unavailable",
      504: "Server not responding",
      default: "An error occurred. Please try again",
    },
    networkError:
      "Cannot connect to server. Please check your network connection",
    requestFailed: "Request failed",
  },

  // User Manuals
  manuals: {
    title: "User Manual",
    fullscreen: "Fullscreen",
    exitFullscreen: "Exit fullscreen",
    notFound: "Manual not found",
    notFoundHint: "No manual file found at {{file}}",
    items: {
      qlcv: "Task Management Guide",
      hrm: "HR Management Guide",
      fieldDefinitions: "CRM Data Dictionary",
    },
  },

  // Profile
  profile: {
    title: "Profile",
    edit: "Edit",
    changeCredential: "Change Password",
    personalInformation: "Personal Information",
    companyInformation: "Company Information",
    accountSettings: "Account Settings",

    // Fields
    loginName: "Login Name",
    firstName: "First Name",
    lastName: "Last Name",
    fullName: "Full Name",
    email: "Email",
    telephone: "Telephone",
    cell: "Cell",
    fax: "Fax",
    pager: "Pager",
    homePhone: "Home Phone",
    companyName: "Company Name",
    employeeNumber: "Employee Number",
    mailStop: "Mail Stop",
    manager: "Manager",
    logonEnabled: "Logon Enabled",
    startingPage: "Starting Page",
    defaultVault: "Default Vault",
    workingDirectory: "Working Directory",

    // Placeholders
    enterFirstName: "Enter first name",
    enterLastName: "Enter last name",
    enterEmail: "Enter email",
    enterTelephone: "Enter telephone",
    enterCell: "Enter cell",

    // Credential fields
    currentCredential: "Current Password",
    newCredential: "New Password",
    confirmCredential: "Confirm Password",
    enterCurrentCredential: "Enter current password",
    enterNewCredential: "Enter new password",
    enterConfirmCredential: "Confirm new password",

    // Validation
    currentCredentialRequired: "Please enter current password",
    newCredentialRequired: "Please enter new password",
    confirmCredentialRequired: "Please confirm password",
    credentialMinLength: "Password must be at least 6 characters",
    credentialMismatch: "Passwords do not match",

    // Messages
    fetchError: "Failed to load profile",
    updateSuccess: "Profile updated successfully",
    updateError: "Failed to update profile",
    credentialChangeSuccess: "Password changed successfully",
    credentialChangeError: "Failed to change password",
  },

  // Import
  import: {
    button: "Import",
    title: "Import Data",

    // Steps
    steps: {
      upload: "Upload File",
      mapping: "Column Mapping",
      preview: "Preview",
      result: "Result",
    },

    // Upload
    dragDropText: "Drag and drop file here or click to browse",
    supportedFormats: "Supported: Excel (.xlsx, .xls) and CSV (.csv)",
    downloadTemplate: "Download template",
    templateHint: "Use template to ensure correct format",
    viewSupportedFields: "View supported fields",
    templateExcel: "Excel Template (.xlsx)",
    templateCSV: "CSV Template (.csv)",
    noResponsiveForm: "This item type does not have a responsive form layout",

    // Mapping
    fileColumn: "File Column",
    targetField: "Target Field",
    selectField: "Select field...",
    ignoreColumn: "Ignore this column",
    requiredFieldsMissing: "Some required fields are not mapped:",
    mappingHint:
      "Map file columns to system fields. Some columns have been automatically detected.",
    status: "Status",

    // Preview
    totalRows: "Total Rows",
    validRows: "Valid",
    invalidRows: "With Errors",
    validationErrorsFound: "Found {{count}} validation errors",

    // Result
    importSuccess: "Import successful!",
    importPartial: "Import completed with some errors",
    importFailed: "Import failed",
    created: "Created",
    failed: "Failed",
    downloadErrors: "Download error list",

    // Update existing records
    updateExisting: "Update duplicate records",
    updateExistingDesc:
      "When enabled, rows matching item_number or name will be updated instead of skipped or rejected",
    updated: "Updated",
    updatedItems: "Updated items",

    // Skip duplicates
    skipDuplicates: "Skip duplicate records",
    skipDuplicatesDesc:
      "When enabled, rows with item_number or name already existing in the system will be skipped",
    skipped: "Skipped",
    skippedDuplicates: "Skipped duplicate records",
    matchField: "Match field",
    matchValue: "Value",
    existingId: "Existing ID",
    importAllSkipped: "All records already exist",

    // Auto-create references
    autoCreateReferences: "Auto-create missing references",
    autoCreateReferencesDesc:
      "When enabled, reference records not found will be automatically created in the system",
    autoCreatedReferences: "Auto-created reference records",
    refItemType: "Type",
    refName: "Name",
    refField: "Field",
    andMore: "and",
    moreItems: "more items",

    // Errors
    errors: {
      invalidFormat:
        "File format not supported. Only .xlsx, .xls, .csv accepted",
      invalidMimeType: "Invalid file type",
      fileTooLarge: "File too large. Maximum size is 10MB",
      emptyFile: "File is empty",
      noHeaders: "File has no header columns",
      noData: "File has no data",
      tooManyRows: "File has too many rows. Maximum 1000 rows per import",
      required: "Required field",
      invalidEmail: "Invalid email",
      invalidDate: "Invalid date",
      invalidNumber: "Invalid number",
      parseError: "Cannot read file. Please check the format",
    },

    // Result details
    row: "Row",
    createdItems: "Created items",
    itemNumber: "Item Number",
    orgCode: "Org Code",
    name: "Name",
    successMessage: "Import successful: {{count}} items imported",
    failedMessage:
      "Import failed: {{count}} rows have errors. See details below.",
    allSkippedMessage: "All {{count}} records already exist and were skipped.",
    templateDownloaded: "Template has been downloaded",

    // Buttons
    next: "Next",
    back: "Back",
    import: "Import",
    done: "Done",
    cancel: "Cancel",
  },

  // Empty State
  emptyState: {
    noData: "No data",
    noDataDescription: "There is nothing to display yet.",
    noItems: "No {{resource}} yet",
    createFirst: "Get started by creating your first {{resource}}.",
  },

  // Time Range
  timeRange: {
    today: "Today",
    "7days": "Last 7 Days",
    "30days": "Last 30 Days",
    quarter: "This Quarter",
    all: "All Time",
    label: "Time Range",
  },

  // Quick Filter
  quickFilter: {
    all: "All",
  },

  // Theme
  theme: {
    toggle: "Toggle dark mode",
    light: "Light Mode",
    dark: "Dark Mode",
  },

  // Bottom Navigation
  bottomNav: {
    lists: "Lists",
  },

  // Relationships
  relationships: {
    title: "Related Items",
  },

  // Item Picker Modal
  itemPicker: {
    searchPlaceholder: "Search by name, number, or description...",
    searchByColumn: "Search by {{column}}...",
    allColumns: "All columns",
    selectedCount: "{{count}} item(s) selected",
    noItems: "No items found",
  },

  // Org Chart
  orgChart: {
    noData: "No department data available",
    departments: "departments",
    rootDepartments: "root",
  },

  // Manager Assignment (Task 32)
  manager: {
    modalTitle: "Assign Manager",
    role: "Role",
    selectRole: "Select role",
    roleRequired: "Please select a role",
    newManager: "New Manager",
    selectUser: "Select user",
    newManagerRequired: "Please select a manager",
    effectiveFrom: "Effective From",
    effectiveFromRequired: "Please select the effective date",
    effectiveTo: "Effective To",
    endReason: "Reason for ending current tenure",
    endReasonDefault: "Default: Replaced",
    notes: "Notes",
    manager: "Manager",
    currentTenure: "Current tenure",
    noHistory: "No manager assignment history yet",
    noIncumbent: "This role currently has no incumbent.",
    incumbentTitle: "This role already has an incumbent",
    incumbentSince: "has held this role since",
    incumbentConfirm:
      "Confirming will close the current tenure and start a new one.",
    confirmReplace: "Confirm replacement",
    confirmAssign: "Assign manager",
    assignSuccess: "Manager updated",
    conflictRetry:
      "Someone else just updated this role. Please review the current incumbent before retrying.",
    historyTabTitle: "Manager history",
    changeButton: "Change manager",
    currentManager: "Current manager",
    vacant: "Vacant",
  },
};
